var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    viewBox: "0 0 44 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7822 16.9366V10.3246L12.5673 0.812278C12.1217 0.296526 11.4739 0 10.7924 0H0L13.9253 16.1244C14.3709 16.6401 15.0186 16.9366 15.7004 16.9366H20.7822Z",
    fill: "#DC4405"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.3302H10.7909C11.4733 36.3302 12.122 36.0331 12.5676 35.5161L20.7825 25.9846V19.3722H15.7011C15.019 19.3722 14.3706 19.6691 13.925 20.1858L0 36.3302Z",
    fill: "#DC4405"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H33.2076C32.5261 0 31.878 0.296526 31.4324 0.812278L23.2175 10.3246V16.9366H28.2996C28.9811 16.9366 29.6291 16.6401 30.0747 16.1244L44 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2175 19.3722V25.9843L31.4324 35.5158C31.878 36.0328 32.5267 36.3299 33.2091 36.3299H44.0003L30.0747 20.1858C29.6291 19.6691 28.9808 19.3722 28.2986 19.3722H23.2175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.faf12e1ad748ddd5fa8ea07deeca203d.svg";
export { ForwardRef as ReactComponent };